import React, { Component } from "react";
import {Link} from 'react-router-dom';
import HamburgerMenu from "./HamburgerMenu/HamburgerMenu";
import { NavbarItems } from "./NavbarItems"
import './Navbar.css'
import caret from '../../images/svg/icon-down-caret.svg'


class Navbar extends Component {
  constructor(props) {
    super(props);
    this.clickCallbackReceiver = this.clickCallbackReceiver.bind(this);
    this.state = {
      clicked: false,
      expandedIndex: null
    };
  }

  clickCallbackReceiver = (clickedValue) => {
    this.setState({ 
      clicked: clickedValue,
      expandedIndex: null
    });
  };

  closeMobileMenu = () => {
    this.setState({ 
      clicked: false,
      expandedIndex: null
    });
  };

  toggleSubmenu = (index, hasSubnav, e) => {
    if (window.innerWidth <= 940 && hasSubnav) {
      e.preventDefault();
      this.setState(prevState => ({
        expandedIndex: prevState.expandedIndex === index ? null : index
      }));
    }
  };

  render() {
    const { clicked, expandedIndex } = this.state;
    return (
      <nav className="NavbarItems">
        <a href="/">
          <img
            className={clicked ? "navbar-logo active" : "navbar-logo"}
            src={require(`../../images/logos/apt-logo.png`)}
            alt="APT logo"
          />
        </a>
        <div className="menu-icon">
          <HamburgerMenu
            state={clicked}
            setState={this.clickCallbackReceiver}
          />
        </div>
        <div className={clicked ? "nav-menu active" : "nav-menu"}>
          <ul>
            {NavbarItems.map((item, index) => {
              let subnav_classname = "subnav-container";

              item.subnavitems.map((childItem) => {
                if (childItem.category !== "") {
                  subnav_classname = "subnav-container has-categories";
                }
                return null;
              });

              const hasSubnav = item.subnavitems.length > 0;
              const isExpanded = expandedIndex === index;

              return (
                <li 
                  key={index} 
                  className={`nav-links-container ${isExpanded ? 'expanded' : ''}`}
                >
                  <Link
                    className={item.className}
                    to={item.url}
                    onClick={(e) => {
                      if (hasSubnav) {
                        this.toggleSubmenu(index, hasSubnav, e);
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                  >
                    {item.title}
                    {hasSubnav && (
                      <img alt="" src={caret}></img>
                    )}
                  </Link>
                  {
                    hasSubnav && (
                      <span className={`${subnav_classname} ${isExpanded ? 'expanded' : ''}`}>
                        {item.subnavitems.map((childItem, childIndex) => {
                          return (
                            <div
                              key={childIndex}
                              className={
                                childItem.category === ""
                                  ? ""
                                  : "subitem-category-container"
                              }
                            >
                              <p className="category-title">
                                {childItem.category}
                              </p>
                              {childItem.items.map((cItemContent, itemIndex) => {
                                return (
                                  <Link
                                    key={itemIndex}
                                    className={cItemContent.className}
                                    to={cItemContent.url}
                                    onClick={this.closeMobileMenu}
                                  >
                                    {cItemContent.title}
                                  </Link>
                                );
                              })}
                            </div>
                          );
                        })}
                      </span>
                    )
                  }
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    );
  }
}

export default Navbar;
